// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"0f2d6cd7","341":"097e630f","647":"abeb2b82"}[chunkId] + ".chunk.css";
};